import styled from 'styled-components';
import { colors } from '_styles';

const ErrorText = styled.span`
  width: 100%;
  font-size: 14px !important;
   
  color: ${colors.RC_RED};
  text-align: left;
  margin-top: 15px;
`;

export default ErrorText;
